import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
// eslint-disable-next-line import/no-internal-modules
import ImageUploadField from '@insided/destination/modules/Customization/configurator/image-upload-field'
import { heroAlignment, GenericHeroConfig } from './index.sync'

interface State {
  heroImage: string
  align: GenericHeroConfig['align']
}

interface PropsForConfigurator extends State {
  onChange: (state: State) => void
}

class GenericHeroConfigurator extends Component<PropsForConfigurator, State> {
  constructor(props: PropsForConfigurator) {
    super(props)
    this.state = {
      heroImage: props.heroImage,
      align: props.align
    }

    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
  }

  componentWillUpdate(nextProps: PropsForConfigurator, nextState: State) {
    if (nextProps.onChange && this.state !== nextState) {
      nextProps.onChange({ heroImage: nextState.heroImage, align: nextState.align })
    }
  }

  handleSelectChange(e: Event) {
    const selectElement = e.target as HTMLSelectElement
    const selectValue = selectElement.value as GenericHeroConfig['align']

    this.setState({ align: selectValue })
  }

  handleUpload(src: string) {
    this.setState({ heroImage: src })
  }

  render() {
    const { align, heroImage } = this.state

    return (
      <div className='hero-banner-wrapper'>
        <InputGroup title='Hero Image'>
          <p>Maximum file size: 5m. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</p>
          <ImageUploadField src={heroImage} onChange={this.handleUpload} />
        </InputGroup>
        <InputGroup title='Alignment'>
          <select name='alignment' className='webmasterSelector' onChange={this.handleSelectChange}>
            {heroAlignment.map((option) => (
              <option style={{ textTransform: 'capitalize' }} key={option} value={option} selected={align === option}>
                {option}
              </option>
            ))}
          </select>
        </InputGroup>
      </div>
    )
  }
}

export default GenericHeroConfigurator
